import React, { useEffect, useState } from 'react';

import { image } from '../../../app/utils/common/image';
import { useNavigate } from 'react-router-dom';
import Button from '../../atoms/Button/Button';
import POINT from '../../../assets/images/point.svg'
import './LandingScreen.scss';
import BackButton from '../../atoms/BackButton/BackButton';
import { useDispatch, useSelector } from 'react-redux';
import { getProfile, selectAllProfile, selectProfileError, selectProfileStatus } from '../../../redux/Slices/ProfileSlice';
import { AppDispatch } from '../../../redux/store';
import Loader from '../../atoms/Loader/Loader';
import sendFirebaseEvent from '../../../app/firebase/sendFirebaseEvent';

const LandingScreen = () => {
    const [loading, setLoading] = useState<boolean>(false);

    const navigate = useNavigate();
    const dispatch: AppDispatch = useDispatch();

    const profile = useSelector(selectAllProfile);
    const profileStatus = useSelector(selectProfileStatus);
    const profileError = useSelector(selectProfileError);

    const handleBackButton = () => {
        navigate('/profile')
    }

    // useEffect(() => {
    //     dispatch(getProfile()); // Dispatch Get Profile action
    // }, []);

    // Profile status loading state
    useEffect(() => {
        if (profileStatus === 'loading') {
            setLoading(true);
        } else if (profileStatus === 'succeeded') {
            const timer = setTimeout(() => {
                setLoading(false);
            }, 800);
            return () => clearTimeout(timer);
        } else if (profileStatus === 'failed') {
            setLoading(false);
            if (profileError?.error?.message === 'Game already completed.') {
                navigate('/profile')
            }
        }
    }, [profileStatus]);

    return (
        <div>
            <BackButton onClick={handleBackButton} />
            <div className='flex login-container' style={{ height: "100vh", overflowY: "hidden" }}>
                <img src={window.innerWidth > 750 ? image.WEBLOGO : image.LOGOBGCOLOR} className='landing-bg-profile' draggable="false"
                    onContextMenu={(e) => e.preventDefault()} />
                {!loading ? <div>
                    <div className='flex landing-flex' >
                        <div>
                            <img src={profile.profile_image ? profile.profile_image : image.INVESTORAVATAR} className='landing-profile' draggable="false"
                                onContextMenu={(e) => e.preventDefault()} />
                        </div>
                        <div className='profile-heading profile-landing-heading' style={{}}>
                            <div>Welcome to</div>
                            <div className='showdown-image'>
                                <img src={image.SHOWDOWNWHITE} className='showdown-image' />
                            </div>
                            {/* <div>The Showdown!</div> */}
                        </div>
                    </div>
                    <div className='profile-heading landing-description'>
                        <img src={POINT} />
                        <div>This web-app is designed to work with the
                            physical board game. Already set up?
                            Let's Get Started!</div>
                    </div>
                    {/* <div className='profile-heading landing-description'>
                        <img src={POINT} />
                        <div>Prepare for the Ultimate Challenge!
                            This web app is your guide through the
                            ultimate showdown. Are you set up?</div>
                    </div> */}
                    <div className='flex buttons-profile' style={{ paddingBottom: "15px" }}>
                        <Button buttonTitle="Continue" onClick={() => { navigate('/showDown') }} className={'profile-width-button'} />
                    </div>
                    <div className='profile-heading landing-description'>
                        {/* <img src={POINT} /> */}
                        <div style={{ paddingLeft: "25px" }}>Don't have the board yet? Click below to
                            grab your board and join the fun!</div>
                    </div>
                    <div className='flex buttons-profile '>
                        <Button buttonTitle='Buy "The Showdown"' onClick={() => {
                            window.open('https://joyjuncture.com',"__blank") 
                            sendFirebaseEvent('shop_now_button', 'user_action', 'shop_now', 'Play Showdown Button Clicked');
                        }} className={'profile-width-button btn-landing'} />
                    </div>
                </div> : <Loader white height='80%' />}
            </div>
        </div>

    )
}

export default LandingScreen